import { createSelector } from 'reselect';

import { getFeatureFlags } from 'ha/modules/FeatureFlags';

import { getIsCharitable } from '../reducer';

const getListingIsCharitable = createSelector(
  [getIsCharitable, getFeatureFlags],
  (isCharitable, { forUkraineTenant }) =>
    forUkraineTenant === 'on' && isCharitable,
);

export { getListingIsCharitable };
